import { Flex } from 'components/Flex';
import { useShiftModalDataContext } from 'modals/ShiftModal/ShiftModalProvider.data.context';
import { WeekdaysEnum } from 'types/graphql';
import { parseVerboseDate } from 'utils';
import { SendToAgenciesInlineIcon, SendToAgenciesText } from '../../SendToAgenciesView.styled';
import { DateTime } from 'luxon';
import { capitalize } from 'utils/capitalize';
import { useSelector } from 'react-redux';
import isUserTimeFormat24hSelector from 'store/selectors/userSelectors/isUserTimeFormat24hSelector';

export function SummaryInfo() {
  const { data } = useShiftModalDataContext();
  const order = data?.order;
  const timeZone = order?.timeZone?.toString();
  const is24hTimeFormat = useSelector(isUserTimeFormat24hSelector);

  return (
    <Flex flexDirection="column" gap="8px">
      <Flex alignItems="center">
        <SendToAgenciesInlineIcon iconName="ShiftsTime" color="PrimaryDefault" />
        <SendToAgenciesText>
          {parseVerboseDate([order?.startAt, order?.endAt], timeZone, is24hTimeFormat)}
        </SendToAgenciesText>
      </Flex>

      {order?.recurrence && (
        <Flex alignItems="center">
          <SendToAgenciesInlineIcon iconName="Recurring" color="PrimaryDefault" />
          <SendToAgenciesText>
            {`${order?.recurrence?.weekdays
              ?.map((weekday: keyof typeof WeekdaysEnum) => capitalize(weekday).slice(0, 3))
              .join(', ')} - ${order?.recurrence?.frequency?.split(' - ')[0]}`}
            {order?.recurrence?.expirationDate &&
              ` • Ends on ${DateTime.fromISO(order?.recurrence?.expirationDate)
                .setZone(timeZone)
                .toFormat('LLL d, yyyy')}`}
          </SendToAgenciesText>
        </Flex>
      )}

      <Flex alignItems="center">
        <SendToAgenciesText>{order?.position.name}</SendToAgenciesText>
      </Flex>
    </Flex>
  );
}
